import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import useMediaQuery from '@mui/material/useMediaQuery';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';

// context
import { useAuth } from '@/auth/AuthContext';

// project imports
import Drawer from './Drawer';
import Header from './Header';
import Footer from './Footer';
import Loader from '../../components/Loader';
import Warning from 'components/warnings/Warning';
//import Breadcrumbs from '../../components/@extended/Breadcrumbs';

// custom hooks
import useAmoChat from 'hooks/useAmoChat';

// config
import projectConfig from '@/projectConfig';

// РАБОТА С TITLE у главных роутеров(все кроме логина/регистрации)
const titles = {
  '/main': 'Главная',
  '/makeAppointment': 'Запись на прием',

  '/medCard': 'Медкарта',
  '/medCard/analysisResults': 'Результаты анализов',
  '/medCard/hospitalizations': 'Госпитализации',
  '/medCard/researches': 'Исследования',
  '/medCard/recipes': 'Рецепты',
  '/medCard/examinations': 'Осмотры',
  '/medCard/directions': 'Направления',
  '/medCard/recommendations': 'Рекомендации',

  '/myAppointments': 'Мои записи',
  '/promotions': 'Акции',
  '/contacts': 'Контакты',
  '/profile': 'Профиль',
  '/cardDoctor': 'Карточка врача',
}

import { handlerDrawerOpen, useGetMenuMaster } from '../../api/menu';

// ==============================|| MAIN LAYOUT ||============================== //

export default function DashboardLayout() {
  const { pathname } = useLocation();
  const { menuMasterLoading } = useGetMenuMaster();

  const { isShowWarning, setIsShowWarning, messageWarning, isVerified } = useAuth();

  const downXL = useMediaQuery((theme) => theme.breakpoints.down('xl'));

  // Плавающая кнопка онлайн-чата amoCRM на всех разделах ЛК.
  // Layout живет внутри RequireVerified, поэтому при выходе/истечении сессии чат удаляется вместе с ним.
  // Чат только для пациентов с полной регистрацией — решение клиники. У остальных карточка
  // в amoCRM создалась бы без ФИО, а переименовать её потом виджет не умеет.
  useAmoChat({ enabled: projectConfig.amoChat.widget && isVerified });

  // работа с title у вкладки
  useEffect(() => {
    if (pathname.startsWith('/myAppointments')) {
      document.title = 'Мои записи';
      return;
    }

    if (pathname.startsWith('/makeAppointment')) {
      document.title = 'Запись на прием';
      return;
    }

    if (pathname.startsWith('/cardDoctor')) {
      document.title = 'Карточка врача';
      return;
    }
    if (pathname.startsWith('/medCard/analysisResults')) {
      document.title = 'Результаты анализов';
      return;
    }
    if (pathname.startsWith('/contacts')) {
      document.title = 'Контакты';
      return;
    }

    const title = titles[pathname] || 'Личный кабинет';
    document.title = title;
  }, [pathname])

  // set media wise responsive drawer
  useEffect(() => {
    handlerDrawerOpen(!downXL);
  }, [downXL]);

  if (menuMasterLoading) return <Loader />;

  return (
    <Box sx={{ display: 'flex', width: '100%' }}>
      <Header />
      <Drawer />

      <Box 
        component="main" 
        sx={{ 
          width: 'calc(100% - 260px)', 
          flexGrow: 1, 
          p: { xs: 2, sm: 3 },
          position: 'relative' 
        }}
      >

        {isShowWarning && (
            <Warning
              title={messageWarning.title}
              description={messageWarning.description}
              onClose={() => setIsShowWarning(false)}
            />
        )}
        <Toolbar sx={{ mt: 'inherit' }} />
        <Box
          sx={{
            ...{ px: { xs: 0, sm: 0} },
            position: 'relative',
            minHeight: 'calc(100vh - 120px)',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          {/* <Breadcrumbs /> */}
          <Outlet />
          <Box sx={{
            mx: {xs: -2, sm: -3},
            mt: 'auto'
          }}>
           <Footer /> 
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
